import { getConsent } from './consent';
import { GA_ID, clearGaCookies } from './consent-core.mjs';

export { GA_ID };

let initialised = false;
let loaded = false;

function gtag() {
  window.dataLayer.push(arguments);
}

/**
 * Consent Mode v2 "basic": gtag.js is injected only after the visitor opts in
 * via the banner, so no request reaches Google before consent — not even the
 * cookieless pings of "advanced" mode. Only analytics_storage is ever granted
 * (we run no ads). Idempotent; public pages only — the caller (AnalyticsGate)
 * never invokes this under /app.
 */
export const initAnalytics = () => {
  if (initialised) return;
  initialised = true;
  const stored = getConsent();
  if (stored?.analytics) loadGtag();
};

function loadGtag() {
  if (loaded) return;
  loaded = true;
  window.dataLayer = window.dataLayer || [];
  gtag('consent', 'default', {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: 'granted',
  });
  gtag('js', new Date());
  // send_page_view off: page_views are sent manually per public route, so
  // GA4's automatic history tracking never follows a user into /app.
  gtag('config', GA_ID, { send_page_view: false });
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);
}

export const updateConsent = (granted) => {
  if (granted) {
    if (loaded) gtag('consent', 'update', { analytics_storage: 'granted' });
    else if (initialised) { loadGtag(); trackPageView(window.location.pathname); }
    return;
  }
  if (loaded) gtag('consent', 'update', { analytics_storage: 'denied' });
  clearGaCookies();
};

export const trackPageView = (path) => {
  if (!loaded) return;
  gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
};

export const trackEvent = (name, params) => {
  if (!loaded) return;
  gtag('event', name, params);
};
